declare global {
  interface Window {
    RulerAnalytics?: {
      trackConversionAsync: (
        payload: Record<string, any>,
        p2?: string,
        p3?: string,
        p4?: number
      ) => void
    }
  }
}

export default function initFormieListener() {
  console.log('initFormieListener loaded')

  document.addEventListener('onAfterFormieSubmit', (e: Event) => {
    e.preventDefault()
    
    const form = (e.target as HTMLElement).closest('form')
    if (!form) return

    const formData = new FormData(form as HTMLFormElement)
    const flatFields: Record<string, any> = {}

    formData.forEach((value, key) => {
      if (
        key === 'CRAFT_CSRF_TOKEN' ||
        key === 'action' ||
        key === 'siteId' ||
        key === 'submitAction' ||
        key === 'g-recaptcha-response'
      ) {
        return
      }

      flatFields[key] = Array.isArray(value) ? value.join(', ') : value
    })

    const rulerPayload = {
      ...flatFields,
      email: flatFields['fields[email]'] || flatFields['fields[emailAddress]'] || '',
      form_id: form.getAttribute('id'),
      form_handle: form.querySelector<HTMLInputElement>('input[name="handle"]')?.value,
      page_url: window.location.href,
    }

    if (window.RulerAnalytics) {
      console.log('Sending to Ruler:', rulerPayload)
      window.RulerAnalytics.trackConversionAsync(rulerPayload, "", "", 500)
    } else {
      console.warn('RulerAnalytics is not available on window.')
    }
  })
}
